module.exports = __webpack_public_path__ + "media/images/faces/male/1-335515c210df358f1f1606419ff10002.jpg";